<template>
	<div style="width: 100%">
		<div
			class="agenda-card-wrapper d-flex justify-space-between align-center pb-3 u-cursor-pointer"
			:style="wrapperStyle"
		>
			<div style="width: 100%">
				<SponsorBadge
					v-if="sponsoredLabel"
					:text="sponsoredLabel"
					:top="'0px'"
					:right="'0px'"
					:icon="'star'"
					:iconSize="10"
					:iconColor="'#ffffff'"
				/>
				<div
					v-if="timeStatus"
					class="agenda-card-wrapper__time-start"
					:style="{ backgroundColor: timeStatus === 'now' ? '#002855' : '#0055a3' }"
				>
					{{ timeStatus === 'now' ? 'Now' : 'Soon' }}
				</div>
				<div class="d-flex align-center justify-space-between">
					<div
              @click="handleToSubSession"
              class="agenda-card-date__wrapper d-flex px-3 align-start">
						<div
							class="agenda-card-date"
							v-bind:style="{ color: isAgendaPast ? '#AAA' : 'var(--username-category-title)' }"
						>
							<div class="agenda-card-date__begin">
								{{
									formatTime(
										agendaEvent.events_agenda_from,
										agendaEvent.agendaTimezone
									)
								}}
							</div>
							<div class="agenda-card-date__end">
								{{
									formatTime(
										agendaEvent.events_agenda_to,
										agendaEvent.agendaTimezone
									)
								}}
							</div>
							<div class="agenda-card-date__end">
								({{ getTimezoneAbbreviation(agendaEvent.agendaTimezone) }})
							</div>
							<div
								v-if="agendaEvent && agendaEvent.tracks"
								class="agenda-card-date__circle-wrapper"
							>
								<div
									v-for="i in agendaEvent.tracks"
									:key="i.track_id"
									class="agenda-card-date__circle"
									:style="{ background: isAgendaPast ? '#AAA' : i.track_color }"
								/>
							</div>
						</div>
						<div class="ml-2">
							<div
								class="agenda-card-title"
								v-bind:style="{
									color: isAgendaPast ? '#AAA' : 'var(--user-name-color)',
								}"
							>
								{{ agendaEvent.events_agenda_title }}
								<div
									class="agenda-card-description mb-0"
									v-bind:style="{
										color: isAgendaPast ? '#AAA' : 'var(--username-category-title)',
									}"
								>
									{{ agendaEvent.events_agenda_text }}
								</div>
							</div>
							<div
								class="agenda-card-location mt-2"
								v-if="agendaEvent && agendaEvent.session_location"
								v-bind:style="{
									color: isAgendaPast ? '#AAA' : 'var(--location-color)',
								}"
							>
								<Icon
									type="pin"
									:color="isAgendaPast ? '#aaa' : 'var(--location-color)'"
									:size="12"
									:pr="4"
								/>
								{{ agendaEvent.session_location }}
							</div>
							<div
								v-if="agendaEvent && agendaEvent.session_limited && !isAgendaPast"
								class="agenda-card-seats"
							>
								Limited seats
							</div>
						</div>
					</div>
					<div class="agenda-card-wrapper__register pr-3" @click="toggleMyAgenda">
						<Icon :type="scheduleIcon.icon" :color="scheduleIcon.color" :size="24" />
					</div>
				</div>
				<div
            @click.prevent="toggleToSubSessionList"
					:style="{ color: isAgendaPast ? '#AAA' : 'var(--text_button_tint)' }"
					v-if="agendaEvent && agendaEvent.subSessionsCount"
					class="agenda-card-wrapper__sub-session mt-3 pt-3 pl-3"
				>
					View Sub-Session(s)
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import { mapActions, mapGetters } from 'vuex'
import SponsorBadge from '@/components/SponsorBadge.vue'
import Dwh from "@/mixins/Dwh";

Vue.use(VueScrollTo)

export default {
	name: 'SubSession',
	components: {
		SponsorBadge,
	},
  mixins: [Dwh],
	props: {
		agendaEvent: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			isTimeStarted: false,
			isSchedule: null,
		}
	},
	methods: {
		...mapActions('event', ['addMyAgenda', 'removeMyAgenda']),
    handleToSubSession(){
      this.$emit('toggleToSubSession', this.agendaEvent.events_agenda_id, this.agendaEvent.events_agenda_text )
    },
		formatTime(timestamp, timezone) {
			const options = {
				hour: '2-digit',
				minute: '2-digit',
				hour12: true,
				timeZone: 'UTC',
			}

			const date = new Date(timestamp * 1000)
			const offset = Number(timezone.timezone_utc.slice(-2))
			const sign = timezone.timezone_utc.slice(3, 4)

			if (sign === '-') {
				date.setHours(date.getHours() - offset)
			} else {
				date.setHours(date.getHours() + offset)
			}

			return date.toLocaleTimeString('en-US', options)
		},

		getTimezoneAbbreviation(timezone) {
			return timezone.timezone_code || 'UTC'
		},
    toggleToSubSessionList() {
      return this.$router.push({
        name: 'sub-session-list',
        query: {
          events_agenda_id: this.agendaEvent.events_agenda_id,
          event_id: this.$route.query.event_id,
        },
      })
    },
    handleTriggerAddMyAgenda() {
      this.sendTrigger({
        category:'Session Details',
        action:'click_add_sub_session_preview',
        module:'Events',
        title:this.agendaEvent.events_agenda_text,
        id1: this.agendaEvent.events_agenda_id,
        id2: this.$route.query.event_id,
      })
    },
    handleRemoveMyAgenda() {
      this.sendTrigger({
        category:'Session Details',
        action:'click_remove_sub_session_preview',
        module:'Events',
        title:this.agendaEvent.events_agenda_text,
        id1: this.agendaEvent.events_agenda_id,
        id2: this.$route.query.event_id,
      })
    },
    toggleMyAgenda() {
			if (!this.isMyAgendaLoading) {
				if (this.isSchedule) {
          this.handleRemoveMyAgenda()
					this.removeMyAgenda({
						id: this.agendaEvent.events_agenda_id,
					})
				} else {
          this.handleTriggerAddMyAgenda()
					this.addMyAgenda({
						id: this.agendaEvent.events_agenda_id,
					})
				}
				this.isSchedule = !this.isSchedule
			}
		},
	},
	watch: {
		agendaEvent: {
			handler() {
				this.isSchedule = this.agendaEvent.is_scheduled
			},
			immediate: true,
		},
	},
	computed: {
		...mapGetters('event', ['isMyAgendaLoading', 'myAgendaIdIsLoading']),
		...mapGetters('settings', ['styles']),
		isSessionDetails() {
			return this.$route.name === 'event-session-by-id'
		},
		wrapperStyle() {
			return {
				paddingTop: this.agendaEvent.sponsored_by || this.timeStatus ? '32px' : '12px',
				borderColor: this.timeStatus ? '#0055a3' : '#e2e2e2',
				backgroundColor: this.isSessionDetails === true ? '#f3f3f6' : '#ffffff',
			}
		},
		timeStatus() {
			const now = new Date()

			const from = new Date(this.agendaEvent.events_agenda_from * 1000)
			const to = new Date(this.agendaEvent.events_agenda_to * 1000)
			const offset = Number(this.agendaEvent.agendaTimezone.timezone_utc.slice(-2))
			const sign = this.agendaEvent.agendaTimezone.timezone_utc.slice(3, 4)

			if (sign === '+') {
				from.setHours(from.getHours() + offset)
				to.setHours(to.getHours() + offset)
			} else {
				from.setHours(from.getHours() - offset)
				to.setHours(to.getHours() - offset)
			}

			const fifteenMinutesInMs = 15 * 60 * 1000

			if (now >= from && now <= to) {
				return 'now'
			} else if (now >= new Date(from.getTime() - fifteenMinutesInMs) && now < from) {
				return 'soon'
			}
			return ''
		},

		sponsoredLabel() {
			return this.agendaEvent.sponsored_by
				? `Sponsored by ${this.agendaEvent.sponsored_by}`
				: ''
		},
		scheduleIcon() {
			return this.isSchedule
				? {
						icon: 'remove_schedule',
						color: '#9B9B9B',
				  }
				: { icon: 'add_schedule', color: 'var(--button-icon-tint)' }
		},
		isAgendaPast() {
			const date = new Date()
			const currentGMTDate = date.getTime() + date.getTimezoneOffset() * 60 * 1000
			const agendaTimezoneOffset =
				+this.agendaEvent.agendaTimezone.timezone_utc.slice(-2) * 60 * 60 * 1000
			const agendaTimeZoneOffsetDirection =
				this.agendaEvent.agendaTimezone.timezone_utc.slice(3, 4) === '+'
			const agendaDate = new Date(this.agendaEvent.events_agenda_to * 1000).getTime()
			const agendaGMTDate =
				agendaDate +
				(agendaTimeZoneOffsetDirection === '+'
					? -agendaTimezoneOffset
					: +agendaTimezoneOffset)
			return currentGMTDate > agendaGMTDate
		},
	},
}
</script>

<style lang="scss">
.agenda-card {
	&-wrapper {
		background: #ffffff;
		border-radius: 8px;
		position: relative;
		margin-bottom: 8px;
		border: 1px solid #e2e2e2;
		&__sub-session {
			border-top: 1px solid #e2e2e2;
			font-family: 'Inter', sans-serif;
			font-weight: 700;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0;
			color: #0055a3;
		}
		&__register {
			width: 30px;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		&__time-start {
			position: absolute;
			top: 0;
			left: 0;
			width: 52px;
			height: 20px;
			background-color: #0055a3;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 12px;
			line-height: 16px;
			letter-spacing: 0;
			color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 6px 0 0 0;
			clip-path: polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 8px) 100%, 0 100%);
		}
	}
	&-seats {
		width: 100px;
		height: 24px;
		background-color: #0055a3;
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 140%;
		letter-spacing: 0;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 20px;
		margin-top: 8px;
	}

	&-date {
		color: var(--accent-color);
		font-size: 13px;
		flex-shrink: 0;
		min-width: 52px;
    &__wrapper {
      width: 100% !important;
    }
		&__begin {
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 13px;
			line-height: 140%;
			letter-spacing: 0;
		}

		&__end {
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 140%;
			letter-spacing: 0;
		}
		&__circle {
			margin-top: 8px;
			width: 6px;
			height: 6px;
			background-color: #674ea6;
			gap: 6px;
			border-radius: 50%;
		}
		&__circle-wrapper {
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
			max-width: calc((6px * 5) + (4px * 4));
		}
	}

	&-description {
		color: var(--username-category-title);
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 16px;
		line-height: 140%;
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		white-space: normal;
	}

	&-tag {
		display: flex;
		align-items: center;
		font-size: 13px;
		font-family: 'Inter', sans-serif;
		font-weight: 700;
		line-height: 19.37px;

		p {
			word-break: break-all;
		}
	}

	&-location {
		display: flex;
		font-family: 'Inter', sans-serif;
		font-weight: 500;
		font-size: 13px;
		line-height: 140%;
		letter-spacing: 0;
	}

	&-schedule {
		&-btn {
			background-color: transparent !important;
			padding: 0 !important;
			min-width: auto !important;
		}
	}
}
</style>
